// @ts-expect-error Types coming soon https://git.hubteam.com/HubSpot/ContentEditorUI/pull/18315
import { makeGetHasTestFlag } from 'ContentEditorUI/redux/selectors/testFlagSelectors';
export const DISABLE_CUSTOM_JITA_UI = 'disableCustomJitaUI';
export const getDisableCustomJitaUI = makeGetHasTestFlag(DISABLE_CUSTOM_JITA_UI);